<template>
	<div class="head-image" @click="showUserInfo($event)" :style="{ cursor: isShowUserInfo ? 'pointer' : null }">
		<img class="avatar-image" v-show="url" :src="url" :style="avatarImageStyle" loading="lazy" />
		<div class="avatar-text" v-show="!url" :style="avatarTextStyle">
			{{ avaterText }}</div>
		<div v-show="online" class="online" :title="$t('personalInfo.userOnline')"></div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "headImage",
	props: {
		id: {
			type: Number
		},
		size: {
			type: Number,
			default: 42
		},
		width: {
			type: Number
		},
		height: {
			type: Number
		},
		radius: {
			type: String,
			default: "50%"
		},
		url: {
			type: String
		},
		name: {
			type: String,
			default: null
		},
		online: {
			type: Boolean,
			default: false
		},
		isShowUserInfo: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		showUserInfo(e) {
			if (!this.isShowUserInfo) return;
			if (this.id && this.id > 0) {
				this.$http({
					url: `/user/find/${this.id}`,
					method: 'get'
				}).then((user) => {
					let pos = {
						x: e.x + 30,
						y: e.y
					}
					this.$eventBus.$emit("openUserInfo", user, pos);
				})
			}
		},
		isChinese(charCode) {
			return charCode >= 0x4e00 && charCode <= 0x9fa5;
		}

	},
	computed: {
		avatarImageStyle() {
			let w = this.width ? this.width : this.size;
			let h = this.height ? this.height : this.size;
			return `width:${w}px; height:${h}px;
					border-radius: ${this.radius};`
		},
		avatarTextStyle() {
			let w = this.width ? this.width : this.size;
			let h = this.height ? this.height : this.size;
			return `width: ${w}px;height:${h}px;
				font-size:${w * 0.4}px;
				border-radius: ${this.radius};`
		},
		avaterText() {
			if (!this.name) return '';
			if (this.isChinese(this.name.charCodeAt(0))) {
				return this.name.charAt(0)
			} else {
				return this.name.charAt(0).toUpperCase() + this.name.charAt(1)
			}
		},
	}
}
</script>

<style scoped lang="scss">
@import "@/assets/style/thems.scss";

.head-image {
	position: relative;

	.avatar-image {
		position: relative;
		overflow: hidden;
		display: block;
	}

	.avatar-text {
		color: #fff;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(
			145deg,
			var(--im-color-primary-light-2) 0%,
			var(--im-color-primary) 52%,
			#{mix(#000, $--color-primary, 20%)} 100%
		);
		box-shadow:
			inset 0 1px 0 rgba(255, 255, 255, 0.3),
			inset 0 -1px 2px rgba(0, 0, 0, 0.12);
	}

	.online {
		position: absolute;
		right: -4px;
		bottom: 0;
		width: 22%;
		height: 22%;
		min-width: 10px;
		min-height: 10px;
		background: var(--im-color-success);
		border-radius: 50%;
		border: 2px solid white;
	}
}
</style>
